console.log(
"LAYER CONTROLS JS LOADED"
);
document.addEventListener("DOMContentLoaded", () => {

  const fontSelector =
    document.getElementById("fontSelector");

  const colorPicker =
    document.getElementById("threadColorPicker");

  const fontSizeSelector =
    document.getElementById("fontSizeSelector");

  fontSelector?.addEventListener("change", () => {

    if(
      !window.selectedEmbroideryLayer
    ) return;

    if(
      !window.selectedEmbroideryLayer.classList.contains(
        "embroidery-text-layer"
      )
    ) return;

    window.selectedEmbroideryLayer.style.fontFamily =
      fontSelector.value;

  });

  colorPicker?.addEventListener("input", () => {

    if(
      !window.selectedEmbroideryLayer
    ) return;

    if(
      !window.selectedEmbroideryLayer.classList.contains(
        "embroidery-text-layer"
      )
    ) return;

    window.selectedEmbroideryLayer.style.color =
      colorPicker.value;

  });

  
document
.getElementById("delete-layer")
?.addEventListener("click", () => {

  console.log("DELETE BUTTON CLICKED");

  if (!window.selectedEmbroideryLayer)
    return;

  const deletedLayer =
    window.selectedEmbroideryLayer;

  deletedLayer.remove();
  if (
  document.querySelectorAll(
    ".embroidery-image-layer"
  ).length === 0
) {

  window.currentComplexity =
    undefined;

  window.currentDigitizingFee =
    0;

  window.currentColorCount =
    0;

  window.detectedArtworkColors =
    0;

  window.detectedArtworkComplexity =
    "Simple";

  window.detectedStitchCount =
    0;

  console.log(
    "ARTWORK DATA RESET"
  );

}

  window.selectedEmbroideryLayer =
    null;

  document.dispatchEvent(
    new Event("embroideryUpdated")
  );

  window.EMBStorage?.save();

  console.log(
    "LAYER DELETED"
  );

});
});